function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: inline-block;\n  height: 10em;\n  width: 10em;\n  font-size: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
var Icon = styled.div.attrs({
  'data-e2e': 'icon'
})(_templateObject(), function (_ref) {
  var size = _ref.size;
  return size + "em";
});
Icon.displayName = 'Icon';
Icon.propTypes = {
  size: PropTypes.number
};
Icon.defaultProps = {
  size: 1
};
export default Icon;